import type { HudPaneelData } from '../../services/voiceScreenService';

/** Kop van een HUD-paneel: type-label + referentie. */
export function paneelKop(paneel: HudPaneelData): { label: string; referentie: string } {
  switch (paneel.soort) {
    case 'offerte':
      return { label: 'Offerte', referentie: paneel.referentie };
    case 'facturen':
      return { label: 'Facturen', referentie: paneel.referentie };
    case 'project':
      return { label: 'Project', referentie: paneel.referentie };
    case 'klant':
      return { label: 'Klant', referentie: paneel.naam };
    case 'planning':
      return { label: 'Planning', referentie: paneel.titel };
    case 'pdf':
      return {
        label: paneel.documentSoort === 'offerte' ? 'Offerte-PDF' : 'Factuur-PDF',
        referentie: paneel.referentie,
      };
    case 'mail':
      return { label: 'Mail', referentie: paneel.afzender };
    case 'mail_concept':
      return { label: 'Concept', referentie: paneel.aanNaam ?? paneel.aan };
  }
}

/** Leesbare titel van een paneel — o.a. voor de doel-resolver van `beheer_scherm`. */
export function paneelTitel(paneel: HudPaneelData): string {
  const kop = paneelKop(paneel);
  return `${kop.label} ${kop.referentie}`;
}
